import { createSelector } from "@ngrx/store";
import { INotasFiscaisReportState } from "./notas-fiscais-report.reducer";

const notasFiscaisReportStore = (state: any) => state.notasFiscaisReport as INotasFiscaisReportState;

export const selectNotasFiscaisReport = createSelector(
    notasFiscaisReportStore,
    (state) => state.notas_fiscais_report
);